export const AssetTransferType = {
   Transfer   : 'Transfer',
   Assignment : 'Assignment',
   Reception  : 'Reception',
   Inventory  : 'Inventory'
 };
 